import { ChevronDown } from '@carbon/icons-react';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import { clsx, colorSet } from '@components/Provider';
import { makeStyles } from '@material-ui/core';
import { useCallback, useState } from 'react';

export interface ProgressInfoReasonProps {
  reasonTitle: string;
  reasonDescription: string;
}

const ProgressInfoReason = ({
  reasonTitle,
  reasonDescription
}: ProgressInfoReasonProps) => {
  const [isHide, setIsHide] = useState(true);
  const { reasonDescriptionText, moreButton } = useStyles();

  const descriptionRef = useCallback((node: HTMLDivElement) => {
    if (!node) {
      return;
    }
    // safari는 scrollHeight가 chrome 보다 1px 높게 측정
    setIsHide(node.offsetHeight < node.scrollHeight - 1);
  }, []);

  const handleMoreRender = () => {
    setIsHide(false);
  };

  return (
    <div>
      <div>
        <CustomizedTypography variant="body2" color="textSecondary">
          {reasonTitle}
        </CustomizedTypography>
      </div>
      <div>
        <CustomizedTypography
          innerRef={descriptionRef}
          variant="body2"
          className={clsx(reasonDescriptionText, { display: !isHide })}
        >
          {reasonDescription}
        </CustomizedTypography>
      </div>
      {isHide && (
        <div className={moreButton}>
          <CustomizedButton variant="text" onClick={handleMoreRender}>
            <CustomizedTypography variant="body2" fontWeight="500">
              더보기
            </CustomizedTypography>
            <ChevronDown color={colorSet.gray900} />
          </CustomizedButton>
        </div>
      )}
    </div>
  );
};

export default ProgressInfoReason;

const useStyles = makeStyles((theme) => ({
  reasonDescriptionText: {
    whiteSpace: 'pre-line',
    wordBreak: 'break-all',
    display: '-webkit-box',
    '-webkit-line-clamp': 3,
    '-webkit-box-orient': 'vertical',
    overflowY: 'hidden',
    '&.display': {
      display: 'block',
      '-webkit-line-clamp': 'inherit',
      '-webkit-box-orient': 'inherit',
      overflowY: 'inherit'
    }
  },
  moreButton: {
    marginTop: 2,
    display: 'flex',
    alignItems: 'center',
    '& .text:hover': {
      textDecorationColor: theme.palette.text.primary
    }
  }
}));
